export class College {
  degreeTypeClassIds: number[] = [];
  collegeTypeClassIds: number[] = [];
  regionClassIds: number[] = [];
  regionStateClassIds: number[] = [];
  citySizeClassIds: number[] = [];
  schoolPopulationClassIds: number[] = [];
  schoolTypeClassIds: number[] = [];
  classSizeClassIds: number[] = [];
  miles = null;
  zipCode = null;
  applicationDueDateInFuture = null;
}
